export default {
  tasks: [],
  categories: [],
  checklists: []
};
